/**
 *  Testimonial Widgets
 */
import React , {Component} from 'react';
import Slider from "react-slick";

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
     adaptiveHeight: true,
    slidesToScroll: 1
  };


class Testimonial extends Component {


   render() {
    return (
            <div className="ciyashop_testimonials_wrapper ciyashop_testimonials-1">
                <div className="testimonial testimonial-style-1">
                <div className="testimonials slick-carousel">
                    <Slider {...settings}>
                        <div className="item">
                            <div className="slick-caption">
                            <i className="fa fa-quote-left" />
                            <p>Modesty has returned with a vehemence not seen since Victorian times and it is not merely limited to the most public of religious codes found in Islam.</p>
                            <div className="client-info">
                                <h5 className="author-name">- Joe Doe</h5>
                                <span>Support</span>
                            </div>
                            <div className="author-photo">
                                 <img className="img-responsive rounded-circle"  src={require(`../assets/images/testimonials/img-01.jpg`)}  alt="Paul Flavius" />
                            </div>
                            </div>

                        </div>
                        <div className="item">
                            <div className="slick-caption">
                            <i className="fa fa-quote-left" />
                            <p>Will this trend transcend politics and borders to unite? It might be a little early to make such a claim, but undoubtedly something is afoot on a global level.</p>
                            <div className="client-info">
                                <h5 className="author-name">- Jessie Flavius</h5>
                                <span>Marketing</span>
                            </div>
                            <div className="author-photo">
                              <img className="img-responsive rounded-circle" src={require(`../assets/images/testimonials/img-02.jpg`)}  alt="Paul Flavius" />
                            </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="slick-caption">
                            <i className="fa fa-quote-left" />
                            <p>Modest dressing has been around since the beginning of time. There is nothing new in covering up.</p>
                            <div className="client-info">
                                <h5 className="author-name">- Felicia Queen</h5>
                                <span>CEO</span>
                            </div>
                            <div className="author-photo">
                                <img className="img-responsive rounded-circle" src={require(`../assets/images/testimonials/img-03.jpg`)}  alt="Paul Flavius" />
                            </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="slick-caption">
                            <i className="fa fa-quote-left" />
                            <p>And if you add in some color, style, and elegance, creative women can more aptly express themselves. Will this trend unite people or at least women? To some extent it already has.</p>
                            <div className="client-info">
                                <h5 className="author-name">- Sara Lisbon</h5>
                                <span>CEO</span>
                            </div>
                            <div className="author-photo">
                                <img className="img-responsive rounded-circle" src={require(`../assets/images/testimonials/img-04.jpg`)}  alt="Paul Flavius" />
                            </div>
                            </div>
                        </div>

                    </Slider>

                    </div>
                    </div>
                </div>
        )
    }
 }

 export default Testimonial;

